import React, { useEffect, useState } from "react";
import keys from "../store/keys";
import { Link, NavLink } from "react-router-dom";
import { setKey, getKey, setStringifiedKey, clearKeys } from "../store/actions";
import { connect } from "react-redux";
import logo from "../media/logo.svg";
import Cookies from 'universal-cookie';
import CategoriesHeader from "./CategoriesHeader";
import { findFlagUrlByIso3Code } from "country-flags-svg";
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import countryService from "../services/country";
import Searchbar from "./Searchbar";

function Header({ session, setKey, setStringifiedKey, clearKeys, ...props }) {

	const [showCurrencyPopup, setShowCurrencyPopup] = useState(false);
	const [keyword, setKeyword] = useState("");
	const [countries, setCountries] = useState([]);

	useEffect(() => {
		reload();
	}, [keyword]);

	const reload = () => {
		countryService.getAll(session.token, keyword)
			.then(result => {
				if (result.data) {
					setCountries(result.data);
				}
			});
	}

	const renderCountries = () => {
		if (countries.length === 0)
			return <tr><td colSpan={3}>No countries found.</td></tr>

		return countries.map(k => {
			return <tr key={k._id} onClick={e => handleChangeCurrency(e, k)} style={{ cursor: 'pointer' }}>
				<td style={{ width: 50 }}><img src={findFlagUrlByIso3Code(k.code)} className="country-flag" /></td>
				<td>{k.title}</td>
				<td className="text-end">{k.currency}</td>
			</tr>
		});
	}

	const handleChangeCurrency = (e, data) => {
		e.preventDefault();
		if(!session.selectedRegion || session.selectedRegion.currency !== data.currency) {
			setStringifiedKey(keys.selectedRegion, data);
			setShowCurrencyPopup(false);
		}
	}

	return (
		<>
			{
				showCurrencyPopup &&
				<Rodal visible={showCurrencyPopup} onClose={() => { setShowCurrencyPopup(false) }} width={400} height={500} customStyles={{ overflowY: 'auto' }}>
					<span className="cart-title mt-10">Change Country/Region</span>
					<hr />
					<span style={{ fontSize: 12, color: 'gray' }}>To get the best ONE OUTNET, make sure you select your location from the list below.</span>
					<Searchbar keyword={keyword} onChange={setKeyword} bordered={true} />
					<hr />
					<table className="table table-responsive mb-30">
						<tbody>
							{renderCountries()}
						</tbody>
					</table>
				</Rodal>
			}
			<nav className="navbar navbar-expand-lg navbar-light bg-white" style={{paddingLeft: 45, paddingRight: 45, height: 60}}>
				<div className="container-fluid justify-content-center">
					<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
						<span className="navbar-toggler-icon"></span>
					</button>

					<div className="collapse navbar-collapse me-auto" id="navbarNav">
						<ul className="navbar-nav w-100 justify-content-start">
							<li className="nav-item">
								<Searchbar keyword={session.searchKeyword} onChange={val => setKey(keys.searchKeyword, val)} bordered={false} />
							</li>
						</ul>
					</div>

					<NavLink className="navbar-brand" to="/">
						<img src={logo} className="header-logo" />
					</NavLink>

					<div className="collapse navbar-collapse ms-auto" id="navbarNav">
						<ul className="navbar-nav w-100 justify-content-end">
							{
								session.isLoggedIn === true &&
								<>
								{
									session.selectedRegion ?
									<li className="nav-item mt-2 mr-10" style={{ cursor: 'pointer' }} onClick={e => setShowCurrencyPopup(true)}>
										{/* <img src={findFlagUrlByIso3Code(session.selectedRegion.code)} className="country-flag" /> */}
										{session.selectedRegion.title}/{session.selectedRegion.currency}
									</li> :
									<li className="nav-item mt-2 mr-10" style={{ cursor: 'pointer' }} onClick={e => setShowCurrencyPopup(true)}>
										{/* <img src={findFlagUrlByIso3Code("NLD")} className="country-flag" /> */}
										NL/EUR
									</li>
								}
									<li className="nav-item">
										<NavLink to="/manage/profile">
											<i className="fa-solid fa-circle-user header-icon"></i>
										</NavLink>
									</li>
									<li className="nav-item">
										<NavLink to="/wishlist">
											<i className="fa-solid fa-heart header-icon"></i>
										</NavLink>
									</li>
									<li className="nav-item">
										<NavLink to="/cart">
											<i className="fa-solid fa-bag-shopping header-icon"></i>
										</NavLink>
									</li>
								</>
							}
							{
								session.isLoggedIn === false &&
								<>
									<li className="nav-item header-text">
										<NavLink to="/login">Login</NavLink>
									</li>
									<li className="nav-item header-text">
										<NavLink to="/signup">Signup</NavLink>
									</li>
								</>
							}
						</ul>
					</div>
				</div>
			</nav>
			<CategoriesHeader />
		</>
	);
}

const mapStateToProps = (store) => ({
	session: store.session,
});

const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
	setStringifiedKey: (key, value) => dispatch(setStringifiedKey(key, value)),
	clearKeys: () => dispatch(clearKeys()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
